import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, Select, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/system';
import { ArrowDown2, ArrowUp2 } from 'iconsax-react';
import { useEffect, useRef, useState } from 'react';
import './style.scss';
import { palette } from '../../../../theme/palette';
import { centered } from '@ui/containers/freelancer/account/style';
import { black300, black500 } from '@ui/constants/color';
const theme = palette('light');
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    '&.Mui-selected': {
        color: theme.palette.primary.main
    }
}));
export default function CustomSelect({ options, selectedOption, defaultOption, label, size = 'medium', labelColor = '#141414', color, fillBackground = true, handleChange, variant = 'outlined', startIcon, borderRadius = true, disabled = false, bgColor = fillBackground ? (disabled ? '#ECECEC' : '#f8f8f8') : 'white', height, errormsg, mt = 0 }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const selectRef = useRef(null);
    const hasSelectedValue = selectedOption !== null && selectedOption !== undefined && selectedOption !== '';
    const placeholderTextColor = black300;
    const selectedTextColor = color || black500;
    const toggleMenu = () => {
        if (disabled)
            return;
        setMenuOpen((prevMenuOpen) => !prevMenuOpen);
    };
    const handleOpen = () => {
        setMenuOpen(true);
    };
    const handleClose = () => {
        setMenuOpen(false);
    };
    useEffect(() => {
        if (variant !== 'outlined') {
            const handleClickOutside = (event) => {
                if (selectRef.current && !selectRef.current.contains(event.target)) {
                    setMenuOpen(false);
                }
            };
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, []);
    const getLabelByValue = (value) => {
        const option = options?.find((option) => option.value === value);
        return option?.label;
    };
    return (_jsx(Box, { width: '100%', mt: mt, className: 'custom-select', children: _jsxs(FormControl, { fullWidth: true, children: [_jsx(Select, { fullWidth: true, size: size, displayEmpty: true, startAdornment: startIcon, variant: variant, labelId: 'demo-simple-select-label', id: 'demo-simple-select', disabled: disabled, renderValue: (selected) => {
                        if (!selected || selected.length === 0) {
                            return (_jsx(Typography, { style: {
                                    fontSize: '14px',
                                    color: placeholderTextColor,
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    display: 'inline-block',
                                    maxWidth: '300px'
                                }, variant: 'body2', children: label }));
                        }
                        return (_jsx(Typography, { style: {
                                fontSize: '14px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                color: selectedTextColor,
                                textOverflow: 'ellipsis',
                                display: 'inline-block',
                                maxWidth: '300px'
                            }, variant: 'body2', children: getLabelByValue(selected) }));
                    }, value: selectedOption, sx: {
                        color: color,
                        height: height ? height : fillBackground ? '' : '50px',
                        '&.Mui-disabled': {
                            backgroundColor: '#ECECEC',
                            '& .MuiSelect-select': {
                                WebkitTextFillColor: '#55555'
                            },
                            '.MuiOutlinedInput-notchedOutline': {
                                borderColor: 'transparent' // Remove border when disabled
                            }
                        },
                        '.MuiOutlinedInput-notchedOutline': {
                            borderColor: 'transparent' // Ensure no border is shown initially
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'transparent' // Remove border color when focused
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'transparent' // Remove border on hover
                        },
                        '&.MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root.Mui-disabled': {
                            borderRadius: borderRadius ? '8px' : '25px',
                            backgroundColor: '#ECECEC'
                        }
                    }, MenuProps: {
                        PaperProps: { sx: { maxHeight: 300 } },
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'center'
                        },
                        transformOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center'
                        }
                    }, onChange: handleChange, open: menuOpen, onClose: handleClose, onOpen: handleOpen, style: {
                        backgroundColor: menuOpen && variant === 'outlined' ? theme.primary.lighter : bgColor ? bgColor : '',
                        transition: 'background-color 0.3s, border-color 0.3s',
                        borderRadius: borderRadius ? '8px' : '25px',
                        borderColor: 'none'
                    }, IconComponent: () => menuOpen ? (_jsx(Box, { onClick: toggleMenu, sx: { cursor: 'pointer', height: '50px', ...centered }, children: _jsx(ArrowUp2, { style: {
                                fontWeight: 'bolder',
                                marginBottom: '4px',
                                color: hasSelectedValue ? selectedTextColor : placeholderTextColor,
                                marginRight: '15px'
                            } }) })) : (_jsx(Box, { onClick: toggleMenu, sx: { cursor: 'pointer', height: '50px', ...centered }, children: _jsx(ArrowDown2, { style: {
                                fontWeight: 'bolder',
                                color: hasSelectedValue ? selectedTextColor : placeholderTextColor,
                                marginBottom: variant === 'outlined' ? '1px' : selectedOption === '' ? '5px' : '-2px',
                                marginRight: '15px'
                            } }) })), children: options?.length > 0 ? (options?.map((option) => (_jsx(StyledMenuItem, { value: option.value, children: option.label }, option.value)))) : (_jsx(StyledMenuItem, { disabled: true, children: defaultOption })) }), errormsg && (_jsx(Box, { sx: { position: 'absolute', bottom: -19, left: 0 }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, color: '#FF0000', children: errormsg }) }))] }) }));
}
